import React, { useContext, useEffect, useState } from 'react'
import { useForm } from "react-hook-form";
import "./StepFour.scss";
import mt_logo from "../../../../assets/images/logo_mt.jpeg";
import embleme from "../../../../assets/images/embleme.jpeg";
import { ElementContext } from '../../../../services/Context/Context';
import DossierSlider from '../../../DossierSlider/DossierSlider';
import ViewModale from '../ViewModale/ViewModale';
import moment from 'moment';
import Api from '../../../../services/Api';
import Erreurs from '../../../Erreurs/Erreurs';
import { useRecoilState } from 'recoil';
import { loadingState } from '../../../../recoil/atoms/loadingAtom';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
const StepFour = ({ activeStep,setActiveStep,nextStep,prevStep,setPaiement, paiement }) => {
  const { register,handleSubmit,reset,formState: { errors },} = useForm({defaultValues: {paiement},});  
  const { elementsData } = useContext(ElementContext); 
  const { categories,marques,modeles } = elementsData; 
  const [ categorie,setCategorie ] = useState('');
  const [ isModalOpen,setIsModalOpen ] = useState(false);
  const api = new Api();
  const [erreurs,setErreurs] = useState([]);
  const [isLoading,setIsLoading ] = useRecoilState(loadingState);
  const [ selectedMarque,setSelectedMarque ] = useState('');
  const [ selectedModele,setSelectedModele ] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
      const cat = categories.filter((p) => p.categorie_id == paiement.infovehicule.categorie)[0];
      if( cat ){
        setCategorie(cat.nomCategorie)
      }
      setSelectedMarque(marques.find(p => p.id == paiement.infovehicule.marque));
      setSelectedModele(modeles.find(p => p.id == paiement.infovehicule.modele ));
 
  },[paiement.infovehicule.categorie])
//  console.log(selectedMarque)
//console.log(paiement)
  const submit =  async () => {
    // nextStep();
    try{
     var formData = new FormData(); setIsLoading(true);
     setErreurs([]);
     formData.append("typeDemandeur",paiement.typeDemandeur)
     Object.entries(paiement.demandeur).forEach(([key, value]) => {
        formData.append(`demandeur[${key}]`, value);
      });
      Object.entries(paiement.infovehicule).forEach(([key, value]) => {
        if (key !== 'dossier') {
          //if(key !== 'modele' && key !== "marque")
            formData.append(`infovehicule[${key}]`, value);
          //else if( key === "marque" ){
          //    console.log(selectedMarque);
          //    formData.append(`infovehicule[${key}]`,selectedMarque.title)
          // }  
          // else if( key === "modele" ){
          //   formData.append(`infovehicule[${key}]`,selectedModele.title)
          // }
        }
    });   
    // Traitement spécifique pour infovehicule.dossier (les fichiers)
   if (Array.isArray(paiement.infovehicule.dossier)) {
       paiement.infovehicule.dossier.forEach((file, index) => {
         formData.append(`infovehicule[dossier][]`, file); // 👈 fichier réel
     });
    }
    //console.log(paiement)
   const response = await api.apiData("post","/paiement/apc/nouveau",formData); 
  // console.log(response);
    if( response.status !== 200 ){
      setErreurs(response.errors);
    }
   else{
       toast.success("Paiement effectué avec succès.");
       if( response.uniqueID ){
           navigate(`/apc/invoice/${response.uniqueID}`);
       }
    }
   // console.log(paiement);
    //navigate(`/apc/invoice/1`);
  }
  catch(e){
    console.log(e)
  }
  finally{
    setIsLoading(false)
  }
  }
  const openFile = () => {
    if (!paiement?.infovehicule?.dossier[0]) return;
    const pdfUrl = URL.createObjectURL(paiement.infovehicule.dossier[0]);
    window.open(pdfUrl, '_blank');
    // Optional: Revoke the object URL after some time to free up memory
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
  }   
 // console.log(paiement)
  return (
    <div className='step-component step-four'>  
      {/* <ViewModale 
       setIsOpen={setIsModalOpen}
       isOpen={isModalOpen}
       paiement={paiement}
      /> */}
      <form onSubmit={handleSubmit(submit)}>
        <div className='step__details'>
           <div className='step__details__group'>
              <div className='step__details__group__elem'>
                <p>Type de demandeur</p> 
                <p>{ paiement.typeDemandeur.charAt(0).toUpperCase() +  paiement.typeDemandeur.slice(1) }</p>
              </div>  
              <div className='step__details__group__elem'>
                <p>Prenom et Nom</p> 
                <p>{ paiement.demandeur.fullName }</p>
              </div>
           </div>
           <div className='step__details__group'>
              <div className='step__details__group__elem'>
                <p>Téléphone</p> 
                <p>{ paiement.demandeur.telephone }</p>
              </div>  
              <div className='step__details__group__elem'>
                <p>Adresse</p> 
                <p>{ paiement.demandeur.adresse || "Non fournie" }</p>
              </div>
           </div>

           <div className='step__details__group'>  
              <div className='step__details__group__elem'>
                <p>type d'autorisation</p> 
                <p>{ paiement.infovehicule.paysDestination === "Guinée" ? "Circulation Temporaire":"Transit"}</p>
              </div>
              <div className='step__details__group__elem'>
                <p>Categorie de Véhicule</p> 
                <p>{ categorie }</p>
              </div>
           </div>
           <div className='step__details__group'>
              <div className='step__details__group__elem'>
                <p>Marque</p> 
                <p>{ selectedMarque.title || "Non fournie" }</p>
              </div>
              <div className='step__details__group__elem'>
                <p>Modèle</p> 
                <p>{ selectedModele.title || "Non fournie"}</p>
              </div>
           </div>
           <div className='step__details__group'>
              <div className='step__details__group__elem'>
                <p>Numéro de chassis</p> 
                <p>{ paiement.infovehicule?.numeroChassis?.join(", ") || "Non fourni" }</p>
              </div>
              <div className='step__details__group__elem'>
                <p>Couleur</p> 
                <p>{ paiement.infovehicule.couleur }</p>
              </div>
           </div>
           <div className='step__details__group'>
            <div className='step__details__group__elem'>
              <p>PTAC(kg)</p> 
              <p>{ paiement.infovehicule.ptac }</p>
            </div>
            <div className='step__details__group__elem'>
               <p>Puissance (CV) </p>
               <p>{ paiement.infovehicule.puissanceFiscale || 0 }</p>
            </div>
           </div>
           <div className='step__details__group'>
            <div className='step__details__group__elem'>
              <p>Poids à vide (kg)</p> 
              <p>{ paiement.infovehicule.poidsAVide || 0 }</p>
            </div> 
            <div className='step__details__group__elem'>
              <p>Poids Total Roulant (kg)</p> 
              <p>{ paiement.infovehicule.poidsTotalRoulant || 0 }</p>
            </div> 
           </div>
           <div className='step__details__group'>
             <div className='step__details__group__elem'>
               <p>Charge Utile</p> 
               <p>{ paiement.infovehicule.chargeUtile || 0 }</p>
             </div>
              <div className='step__details__group__elem'>
                <p>Date de prémière mise en circulation</p> 
                <p>{ moment(paiement.infovehicule.dateMiseCirculation).format("DD/MM/YYYY") }</p>
              </div> 
           </div>
           <div className='step__details__group'>
            <div className='step__details__group__elem'>
                <p>Pays de provenance</p> 
                <p>{ paiement.infovehicule.paysProvenance }</p>
              </div>
             <div className='step__details__group__elem'>
                <p>Pays de destination</p> 
                <p>{ paiement.infovehicule.paysDestination }</p>
              </div>
              
           </div>
           <div className='dossier__image' onClick={() => openFile()}>
              <h4>Voir les documents</h4> 
           </div>
          </div>
        <Erreurs validation={erreurs} />   
        <div className="buttons">
          <button className="secondary" onClick={prevStep}>
            Précedent
          </button>
          <button className="" type='submit'>
            Terminer
          </button>
        </div>
       </form> 
    </div>
  )
}

export default StepFour
